<script lang="ts" setup>
import { useArticleStore } from '@/stores'

const articleStore = useArticleStore()

const categories = computed(() => {
  return [
    {
      title: 'All',
      link: '/hence',
    },
    ...articleStore.projectCategories.map(item => {
      return {
        link: `/hence/${item.id}`,
        title: item.subject
      }
    }),
    {
      title: '恆食堂',
      link: '/hence/recipe',
    },
    // {
    //   title: '專題報導',
    //   link: '/hence/topic',
    // },
    // {
    //   title: '歷期雜誌',
    //   link: '/hence/magazine',
    // },
  ]
})

const refLists = ref(null)

onMounted(() => {
  categories.value.forEach((item: any, index: number) => {
    const element = refLists.value?.querySelectorAll('a')[index]
    if (element.classList.contains('router-link-active')) {
      const scrollX = element.getBoundingClientRect().x
      const scrollLeft = scrollX - refLists.value.clientWidth / 2
      refLists.value.scrollLeft = scrollLeft
    }
  })
})
</script>

<template>
  <section class="pageLink" ref="refLists">
    <nuxt-link :to="item.link" v-for="(item, index) in categories" :key="index">
      <h1 v-if="$route.name === 'hence' && index === 0">{{ item.title }}</h1>
      <template v-else>{{ item.title }}</template>
      <svg-icon name="icon-symbol" />
    </nuxt-link>
  </section>
</template>

<style lang="scss" scoped>
.pageLink {
  display: flex;
  // justify-content: center;
  width: 100%;
  margin-bottom: toRem(50);
  padding-bottom: toRem(20);
  overflow-x: auto;

  a {
    position: relative;
    padding-left: toRem(24);
    padding-right: toRem(24);
    font-size: toRem(16);
    font-weight: 400;
    line-height: 1.45;
    color: rgba($color-black-1, 0.5);
    white-space: nowrap;

    svg {
      position: absolute;
      left: 50%;
      bottom: toRem(-15);
      margin-left: toRem(-7.5);
      width: toRem(17);
      height: toRem(9);
      color: $color-brand-4_1;
      pointer-events: none;
      opacity: 0;
      transform: scaleX(0);
      transition: all 0.5s;
    }

    &:hover,
    &.router-link-exact-active {
      color: $color-brand-4_1;

      svg {
        opacity: 1;
        transform: scaleX(1);
      }
    }
  }
}
</style>
